/* global NodeListOf */
import React, {useEffect} from 'react'
import {useSpring, animated} from 'react-spring/web.cjs'
import {Box, Grid, Hidden} from '@material-ui/core'

const calc = (x: number, y: number) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
const b = (x: any | undefined) => `translateY(${x / 30}px`

const Three = () => {
  const [propsSpring, set] = useSpring(() => ({xy: [0, 0], config: {mass: 1, tension: 400, friction: 50}}))

  useEffect(() => {
    const b: NodeListOf<HTMLElement> = document.querySelectorAll('.bobble')
    Array.from(b).map((i) => i.setAttribute('style', `height: ${i.offsetWidth}px`))
  }, [])

  return (
    <Grid container justify={'center'} alignItems={'center'} onMouseMove={({clientX: x, clientY: y}) => set({xy: calc(x, y)})}>
      <Box position={'absolute'} className={'parallax_container'}>
        <Hidden smDown>
          <animated.img className={'three_b1'} src={`/img/page3/b1.png`} style={{transform: propsSpring.xy.interpolate(b)}} />
          <img className={'three_b2'} src={`/img/page3/b-other.png`} alt={''} />
        </Hidden>
        <Hidden mdUp>
          <img className={'three_b1'} src={`/img/page3/b1.png`} alt={''} />
          <img className={'three_b2'} src={`/img/page3/b-other.png`} alt={''} />
        </Hidden>
      </Box>

      <Grid item xs={12} sm={12}>
        <Grid container spacing={1} justify={'space-around'} alignItems={'center'}>
          <Grid item xs={6} md={3} className={'bobble animated pulse infinite'}>
            <Grid container justify={'center'} alignItems={'center'} style={{height: '100%'}}>
              <Grid item xs={12}>
                <span>Яркий</span>
                <br />
                креатив
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} md={3} className={'bobble animated pulse infinite'}>
            <Grid container justify={'center'} alignItems={'center'} style={{height: '100%'}}>
              <Grid item xs={12}>
                <span>Качественная</span>
                <br />
                реализация
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} md={3} className={'bobble animated pulse infinite'}>
            <Grid container justify={'center'} alignItems={'center'} style={{height: '100%'}}>
              <Grid item xs={12}>
                <span>Эффективные</span>
                <br />
                результаты
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} md={3} className={'bobble animated pulse infinite'}>
            <Grid container justify={'center'} alignItems={'center'} style={{height: '100%'}}>
              <Grid item xs={12}>
                <span>Сильный</span>
                <br />
                клиентский сервис
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Three
